import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Announcement from "../components/Announcement";
import FixMenu from "../components/FixMenu";
import Header from "../components/Header";

const ContactOverPhone = () => {

  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);
  const [show5, setShow5] = useState(false);

  const toggleShow1 = () => {
    setShow1(!show1);
    if (show2) {
      setShow2(false);
    }
    else if (show3) {
      setShow3(false);
    }
    else if (show4) {
      setShow4(false);
    }
    else if (show5) {
      setShow5(false);
    }
  };

  const toggleShow2 = () => {
    setShow2(!show2);
    if (show1) {
      setShow1(false);
    }
    else if (show3) {
      setShow3(false);
    }
    else if (show4) {
      setShow4(false);
    }
    else if (show5) {
      setShow5(false);
    }
  };

  const toggleShow3 = () => {
    setShow3(!show3);
    if (show2) {
      setShow2(false);
    }
    else if (show1) {
      setShow1(false);
    }
    else if (show4) {
      setShow4(false);
    }
    else if (show5) {
      setShow5(false);
    }
  };

  const toggleShow4 = () => {
    setShow4(!show4);
    if (show2) {
      setShow2(false);
    }
    else if (show3) {
      setShow3(false);
    }
    else if (show1) {
      setShow1(false);
    }
    else if (show5) {
      setShow5(false);
    }
  };

  const toggleShow5 = () => {
    setShow5(!show5);
    if (show2) {
      setShow2(false);
    }
    else if (show3) {
      setShow3(false);
    }
    else if (show4) {
      setShow4(false);
    }
    else if (show1) {
      setShow1(false);
    }
  };

  // const toggleShow6 = () => {
  //   if (show2) {
  //     setShow2(false);
  //   }
  //   else if (show3) {
  //     setShow3(false);
  //   }
  //   else if (show4) {
  //     setShow4(false);
  //   }
  //   else if (show1) {
  //     setShow1(false);
  //   }
  //   else if (show5) {
  //     setShow5(false);
  //   }
  // };

  // const toggleShow7 = () => {
  //   if (show2) {
  //     setShow2(false);
  //   }
  //   else if (show3) {
  //     setShow3(false);
  //   }
  //   else if (show4) {
  //     setShow4(false);
  //   }
  //   else if (show1) {
  //     setShow1(false);
  //   }
  //   else if (show5) {
  //     setShow5(false);
  //   }
  // };

  return (
    <>
      <div id="bodyaddid">
        <Header />
        <FixMenu />
        <section className="main-banner">
          <div
            className="innerpagebanner"
            style={{
              backgroundImage:
                "url(" + "assets/img/inner/payment-collection.jpg" + ")",
              backgroundPosition: "center",
              backgroundSize: "100% auto",
            }}
          >
            <div className="container">
              <div className="row justify-content-center"></div>
            </div>
          </div>
          <Announcement />
        </section>
        <section className="main_sectiods">
          <div className="container main_bdy">
            <div className="row justify-content-center padtops">
              <div className="col-sm-12">
                <div className="row bg_cols">
                  <div className="col-sm-12">
                    <div className="form_div">
                      <div className="tab-content tab_main">
                        <div
                          className="tab-pane fade show active"
                          id="checkcollection"
                        >
                          <div className="row cashcollectioncenter">
                            <legend>Contact Over Phone</legend>
                            <hr />
                            <div className="innwrper">
                               <div className="contactOver">  
                                <div className="col-sm-6">24*7 Call Center / Customer Care number </div>
                                <div className="col-sm-6">0120 - 622 6666</div>
                                </div>  
                                <div className="contactOver">  
                                <div className="col-sm-6">No Power complaint E-mail</div>
                                <div className="col-sm-6">nocurrentnpcl@rpsg.in</div>
                                </div>  
                                <div className="contactOver">  
                                <div className="col-sm-6">General query complaint E-mail</div>
                                <div className="col-sm-6">crmnpcl@rpsg.in</div>
                                </div>  
                            </div>

                            {/* <div className="innwrper">
                              <table table table-responsive col-sm-12>
                                <tr>
                                  <td>
                                <Link 
                                className="nav-link active"
                                data-toggle="tab"
                                 to="#" onClick={toggleShow1}>Customer Relation</Link>
                                </td>
                                <td>
                                <Link to="#" onClick={toggleShow2}>New Connection - Operations</Link>
                                </td>
                                <td><Link to="#" onClick={toggleShow3}>Operations & Maintenance - Zone-1</Link></td>
                                <td><Link to="#" onClick={toggleShow4}>Operations & Maintenance - Zone-2</Link></td>                             
                                </tr>
                                <tr><td><Link to="#" onClick={toggleShow5}>Commercial Services</Link></td></tr>
                              </table>                         
                            </div> */}

<div>
<ul className="nav nav-tabs nav_tbds">
                    <li className="nav-item">
                      <Link
                        to="#" onClick={toggleShow1}
                        className="nav-link active"
                        data-toggle="tab"
                      >
                        Customer Relation
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#" onClick={toggleShow2}
                        className="nav-link"
                        data-toggle="tab"
                      >
                        New Connection - Operations
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#" onClick={toggleShow3}
                        className="nav-link"
                        data-toggle="tab"
                      >
                        Operations & Maintenance - Zone-1
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#" onClick={toggleShow4}
                        className="nav-link"
                        data-toggle="tab"
                      >
                        Operations & Maintenance - Zone-2
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link
                        to="#" onClick={toggleShow5}
                        className="nav-link"
                        data-toggle="tab"
                      >
                        Commercial Services
                      </Link>
                    </li>
                    <li className="nav-item">
  <a 
    href="https://www.noidapower.com/whatsapp_based_services" 
    className="nav-link"
    target="_blank" 
    rel="noopener noreferrer"
  >
    Whatsapp based Services
  </a> 
</li>

                    <li className="nav-item">
                        <a 
    href="https://iwebapps.noidapower.com:8032/SMS_based_Services.aspx" 
    className="nav-link"
    target="_blank" 
    rel="noopener noreferrer"
  >
   SMS based Services
  </a> 
                    </li>
                  </ul>
</div>

                            {show1 ? (
<div className="innwrper">                      
<table className="table table-responsive col-sm-12">
<tr>

<td className="col-sm-2"> <strong>Heading</strong> </td>
<td className="col-sm-3">  <strong>Sub-Heading</strong> </td>
<td className="col-sm-7">
    <table className="table table-responsive">
      <tr>
        <td className="col-sm-5"> <strong>Name</strong> </td>
        <td className="col-sm-4"> <strong>Designation</strong> </td>
        <td className="col-sm-3"> <strong>Mobile</strong>   </td>                                   
      </tr>     
  </table>
</td>
</tr>
<tr>
<td className="col-sm-2"> Customer Relation </td>
<td className="col-sm-3"> General queries / requests / complaints /information </td>
<td className="col-sm-7">
    <table className="table table-responsive">
      <tr>
        <td className="col-sm-5"> Mr. Tarun Goel</td>
        <td className="col-sm-4"> Manager - BE&CR</td>
        <td className="col-sm-3"> 7065049847</td>                                   
      </tr>
      <tr>
        <td> Mr. Prabhat Ranjan</td>
        <td> Dy. Manager - BE&CR</td>
        <td> 7065049851</td>                                   
      </tr>
      <tr>
        <td> Ms. Neha Rai </td>
        <td> Manager - BE&CR</td>
        <td> 7065049852</td>                                   
      </tr>
    </table>        
</td>
</tr>
<tr>
<td></td>
<td>Overall</td>
<td>
<table className="table table-responsive">
      <tr>
        <td className="col-sm-5">  Ms. Meghna Dosi  </td>
        <td className="col-sm-4">  Head - BE&CR </td>
        <td className="col-sm-3"> 7840008873</td>                                   
      </tr>
    </table>   
</td>
</tr>
</table>
</div>
) : null}

{show2 ? (
  <div className="innwrper">
                            <table className="table table-responsive col-sm-12">
                            <tr>

<td className="col-sm-2"> <strong>Heading</strong> </td>
<td className="col-sm-10">
    <table className="table table-responsive">
      <tr>
        <td className="col-sm-5">  <strong>Sub-Heading</strong> </td>
        <td className="col-sm-4"> <strong>Name</strong> </td>
        <td className="col-sm-3"> <strong>Designation</strong> </td>
        <td className="col-sm-3"> <strong>Mobile </strong>  </td>                                   
      </tr>

  </table>
</td>
</tr>
                              <tr>
                              <td className="col-sm-2"> New Connection - Operations</td>
                              <td className="col-sm-10">
                                  <table className="table table-responsive">
                                    <tr>
                                      <td className="col-sm-5"> New Connection(LT URBAN - Upto 50 KW)</td>
                                      <td className="col-sm-4"> Mr. Amit Kumar </td>
                                      <td className="col-sm-3"> Dy. Manager - (Distribution Technical) </td>     
                                      <td className="col-sm-3"> 9911998247 </td>                                 
                                    </tr>
                                    <tr>
                                      <td>  New Connection(LT RURAL - Upto 50 KW)</td>
                                      <td>   Mr. Sushil Sonar </td>
                                      <td>  Manager - (Distribution Technical) </td>     
                                      <td>  7834807046 </td>                                   
                                    </tr>
                                    <tr>
                                      <td>  New Connection(HT - > 50  KW)</td>
                                      <td>   Mr. Akash Vishwakarma </td>
                                      <td>  Manager - (Distribution Technical) </td>     
                                      <td>  8750068225 </td>                                   
                                    </tr>
                                    <tr>
                                      <td> Coversion of single point connection to multi point connection for multi-storied building</td>
                                      <td> Mr. Tarun Chauhan  </td>                                      
                                      <td> Assistant Manager - (Distribution Technical)</td>     
                                      <td> 9911998208</td>                                   
                                    </tr>
                                    <tr>
                                      <td> New Connection Head </td>
                                      <td> Mr. Pankaj Palawat</td>
                                      <td> Sr. Manager - (Distribution Technical)</td>     
                                      <td> 8287238929</td>                                   
                                    </tr>
                                  </table>        
                              </td>
                              </tr>
                      </table>
                            </div>
) : null}

{show3 ? (
  <div className="innwrper">
  <table className="table table-responsive col-sm-12">
  <tr>

<td className="col-sm-2"> <strong>Heading</strong> </td>
<td className="col-sm-10">
    <table className="table table-responsive">
      <tr>
        <td className="col-sm-5">  <strong>Sub-Heading</strong> </td>
        <td className="col-sm-4"> <strong>Name</strong> </td>
        <td className="col-sm-3"> <strong>Designation</strong> </td>
        <td className="col-sm-3"> <strong>Mobile</strong>   </td>                                   
      </tr>

  </table>
</td>
</tr>
    <tr>
    <td className="col-sm-2"> Operations & Maintenance - Zone-1</td>
    <td className="col-sm-10">
        <table className="table table-responsive">
          <tr>
            <td className="col-sm-5"> Surajpur-1 (Site C/Site B/ Udyog Vihar/Udyog  kendra/B2P area/Ecotech-3 etc.)</td>
            <td className="col-sm-4"> Mr. Bhairab Bose</td>
            <td className="col-sm-3"> Dy. Manager - Operations  </td>     
            <td className="col-sm-3"> 7834807030 </td>                                 
          </tr>
          <tr>
            <td>  Surajpur-2 (Surajpur/Kuleshra/Tilapta/Devla/ Jalpura/ Haldauni/Habibpur/ Thapkhera/Boraki/Pali/Ghori etc.)</td>
            <td>  Mr. Siddharth Makija </td>
            <td>  Dy. Manager - Operations </td>     
            <td>  8743009893 </td>                                   
          </tr>
          <tr>
            <td> Greater Noida West (Societies of GNW/Ecotech-12/ Techzon-4/Sec-10/Ithehra etc.)</td>
            <td> Mr. Inder Pal Singh Lodhi  </td>                                      
            <td> Dy. Manager - Operations</td>     
            <td> 8743009896</td>                                   
          </tr>
          <tr>
            <td> Zone-1 Head </td>
            <td> Mr. Gaurav Sharma</td>
            <td> Sr. Manager - Operations</td>     
            <td> 9990046407</td>                                   
          </tr>
        </table>        
    </td>
    </tr>
</table>
  </div>
) : null}

{show4 ? (
  <div className="innwrper">
  <table className="table table-responsive col-sm-12">
  <tr>

<td className="col-sm-2"><strong> Heading </strong></td>
<td className="col-sm-10">
    <table className="table table-responsive">
      <tr>
        <td className="col-sm-5"> <strong>Sub-Heading</strong>  </td>
        <td className="col-sm-4"> <strong>Name</strong> </td>
        <td className="col-sm-3"> <strong>Designation</strong> </td>
        <td className="col-sm-3"> <strong>Mobile</strong>   </td>                                   
      </tr>

  </table>
</td>
</tr>
    <tr>
    <td className="col-sm-2"> Operations & Maintenance - Zone-2 </td>
    <td className="col-sm-10">
        <table className="table table-responsive">
          <tr>
            <td className="col-sm-5"> Urban-1(Alpha/Beta/Gamma/Delta/ Eta/Zeta/Tughalpur/KP1/ KP2/KP3/KP4 etc.)</td>
            <td className="col-sm-4"> Mr. Tarun Chauhan</td>
            <td className="col-sm-3"> Asst. Manager - Operations  </td>     
            <td className="col-sm-3"> 9911998208 </td>                                 
          </tr>
          <tr>
            <td> Urban-2 & Kasna (Sigma/ Omicron/ ZU/MU/Chi/Builders area/swarn Nagri /Site-4/Site-5/Ecotech Ext-1/Ecotech-6 etc.)Urban-2 (Sigma/ Omicron/ ZU/MU/Chi/Builders area/swarn Nagri) </td>
            <td> Mr. K A Shashwat </td>
            <td> Dy. Manager – Operations </td>     
            <td> 8010933454 </td>                                   
          </tr>
          <tr>
            <td> Kasna (Kasna, Site-4/Site-5/Ecotech Ext-1/Ecotech-6 etc.)</td>
            <td> Mr. Awadhesh Pradeep Fulzade </td>
            <td> Asst. Manager - Operations </td>     
            <td> 8744052911 </td>                                   
          </tr>
          <tr>
            <td> Zone-2-Head</td>
            <td> Mr. Bhupesh Yadav  </td>                                      
            <td> Sr. Manager - Operations </td>     
            <td> 8750048486 </td>                                   
          </tr>        
        </table>        
    </td>
    </tr>
</table>
  </div>
) : null}

{show5 ? (
  <div className="innwrper">
  <table className="table table-responsive col-sm-12">
  <tr>

<td className="col-sm-2"><strong> Heading</strong> </td>
<td className="col-sm-10">
    <table className="table table-responsive">
      <tr>
      <td className="col-sm-5"><strong>Sub-Heading</strong></td>
<td className="col-sm-4"><strong>Name</strong></td>
<td className="col-sm-3"><strong>Designation</strong></td>
<td className="col-sm-3"><strong>Mobile</strong></td>                        
      </tr>

  </table>
</td>
</tr>
    <tr>
    <td className="col-sm-2"> Commercial Services </td>
    <td className="col-sm-10">
        <table className="table table-responsive">
          <tr>
            <td className="col-sm-5"> Reconnection / Disconnection</td>
            <td className="col-sm-4"> Mr. Ritesh Kumar Gupta</td>
            <td className="col-sm-3"> Sr. Executive - Commercial </td>     
            <td className="col-sm-3"> 9355455678 </td>                                 
          </tr>
          <tr>
            <td> Reconnection / Disconnection (Rural)</td>
            <td>  Mr. Tarun Raj </td>     
            <td> Dy.Manager - Commercial Recovery </td>
            <td>9911998254</td>
          </tr>
          <tr>
            <td> Meter reading & Billing</td>
            <td>  Mr. Abhishake Jain </td>     
            <td> DGM - Commercial</td>
            <td>9718804962</td>
          </tr>
          <tr>
            <td> Commercial services (Name mutation/load reduction/category transfer/Permanent disconnection/Security deposit refund) </td>
            <td> Mr. Navin Kumar </td>                                      
            <td> Manager - Commercial </td>     
            <td> 9891701264</td>                                   
          </tr>
          <tr>
            <td> Advertisement on Bill </td>
            <td> Mr. Nikhil Garg </td>                                      
            <td> DGM - Commercial </td>     
            <td> 9990046406</td>                                   
          </tr>
          <tr>
            <td> Overall</td>
            <td> Mr. Praveen Goyal </td>                                      
            <td> Head - Commercial </td>     
            <td> 9718065622 </td>                                   
          </tr>

        </table>        
    </td>
    </tr>
</table>
</div>
) : null}

                            <div style={{ marginTop: "10px" }}>
                              <a style={{ textDecoration: "none" }}>
                                Calls to NPCL officials shall be accepted during
                                office hours.
                              </a>
                            </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default ContactOverPhone;



// import { Card, Tabs, Table, Typography, Space, Row, Col, Divider } from "antd";
// import { PhoneOutlined, MailOutlined, UserOutlined } from "@ant-design/icons";
// import Header from "../components/Header";
// import FixMenu from "../components/FixMenu";

// const { Title, Text } = Typography;
// const { TabPane } = Tabs;

// const ContactOverPhone = () => {
//   const styles = {
//     container: {
//       minHeight: "100vh",
//       background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       padding: "10px 0",

//     },
//     mainContainer: {
//       maxWidth: "1200px",
//       margin: "0 auto",
//       padding: "0 15px",

//     },
//     mainCard: {
//       borderRadius: "12px",
//       boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
//       border: "none",
//       overflow: "hidden",
//       marginBottom: '85px'

//     },
//     contactHeader: {
//       textAlign: "center",
//       padding: "15px 0 10px 0",
//       background: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
//       margin: "-24px -24px 20px -24px",
//     },
//     contactTitle: {
//       margin: "0 !important",
//       color: "#2c3e50",
//       fontWeight: 600,
//       fontSize: "24px",
//     },
//     titleIcon: {
//       marginRight: "8px",
//       color: "#3498db",
//       fontSize: "24px",
//       rotate: '89deg'
//     },
//     quickContactSection: {
//       marginBottom: "25px",
//     },
//     quickContactCard: {
//       textAlign: "center",
//       borderRadius: "8px",
//       border: "1px solid #e8f4fd",
//       transition: "all 0.3s ease",
//       height: "100px",
//       display: "flex",
//       alignItems: "center",
//       justifyContent: "center",
//       cursor: "pointer",
//       padding: "10px",
//     },
//     quickContactIcon: {
//       fontSize: "24px",
//       marginBottom: "4px",
//     },
//     phoneIcon: {
//       color: "#27ae60",
//       rotate: '89deg'
//     },
//     emailIcon: {
//       color: "#e74c3c",
//     },
//     contactNumber: {
//       color: "#27ae60 !important",
//       margin: "0 !important",
//       fontWeight: 700,
//       fontSize: "18px",
//     },
//     emailText: {
//       color: "#3498db",
//       fontWeight: 500,
//       fontSize: "13px",
//     },
//     detailedContactSection: {
//       marginBottom: "20px",
//     },
//     tabContentCard: {
//       borderRadius: "8px",
//       border: "1px solid #e8f4fd",
//       boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
//       padding: "15px",
//     },
//     contactTable: {
//       marginTop: "10px",
//     },
//     contactIcon: {
//       color: "#6c757d",
//       marginRight: "6px",
//       fontSize: "14px",

//     },
//     phoneContactIcon: {
//       color: "#28a745",
//       marginRight: "6px",
//       fontSize: "14px",
//       rotate: '89deg'
//     },
//     officeHoursNotice: {
//       marginTop: "20px",
//     },
//     noticeCard: {
//       background: "linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%)",
//       border: "1px solid #ffeaa7",
//       borderRadius: "8px",
//       textAlign: "center",
//       padding: "10px",
//     },
//     noticeText: {
//       fontSize: "14px",
//       fontWeight: 500,
//       color: "#856404",
//       margin: 0,
//     },
//   };

//   // Compact Custom CSS
//   const customStyles = `
//     .contact-tabs .ant-tabs-nav {
//       margin-bottom: 15px;
//     }
    
//     .contact-tabs .ant-tabs-tab {
//       padding: 8px 16px;
//       font-weight: 600;
//       border-radius: 6px 6px 0 0;
//       font-size: 14px;
//       margin-right: 4px;
//     }
    
//     .contact-tabs .ant-tabs-tab-active {
//       background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
//       color: white !important;
//     }
    
//     .contact-tabs .ant-tabs-tab-active .ant-tabs-tab-btn {
//       color: white !important;
//     }
    
//     .contact-tabs .ant-tabs-content-holder {
//       padding: 0;
//     }
    
//     .contact-table .ant-table-thead > tr > th {
//       background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
//       border-bottom: 1px solid #dee2e6;
//       font-weight: 600;
//       color: #495057;
//       padding: 8px 12px;
//       font-size: 13px;
//     }
    
//     .contact-table .ant-table-tbody > tr:hover > td {
//       background: #f8f9ff !important;
//     }
    
//     .contact-table .ant-table-tbody > tr > td {
//       border-bottom: 1px solid #f0f0f0;
//       padding: 10px 12px;
//       font-size: 13px;
//     }
    
//     .quick-contact-card:hover {
//       transform: translateY(-2px);
//       box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
//     }
    
//     .ant-divider {
//       margin: 10px 0;
//     }
    
//     .ant-card-body {
//       padding: 20px;
//     }
    
//     .tab-content-card .ant-card-body {
//       padding: 0;
//     }
    
//     .notice-card .ant-card-body {
//       padding: 0;
//     }
    
//     @media (max-width: 768px) {
//       .contact-title {
//         font-size: 20px !important;
//       }
      
//       .title-icon {
//         font-size: 20px;
//       }
      
//       .quick-contact-icon {
//         font-size: 20px;
//       }
      
//       .quick-contact-card {
//         height: 85px;
//         margin-bottom: 10px;
//       }
      
//       .contact-tabs .ant-tabs-tab {
//         padding: 6px 10px;
//         font-size: 12px;
//       }
//     }
    
//     @media (max-width: 576px) {
//       .contact-title {
//         font-size: 18px !important;
//       }
      
//       .title-icon {
//         font-size: 18px;
//         margin-right: 6px;
//       }
      
//       .quick-contact-icon {
//         font-size: 18px;
//       }
      
//       .contact-number {
//         font-size: 16px !important;
//       }
      
//       .quick-contact-card {
//         height: 80px;
//       }
//     }
//   `;

//   const customerRelationsData = [
//     {
//       key: "1",
//       name: "Mr. Tarun Goel",
//       designation: "Manager - BE&CR",
//       mobile: "7065049847",
//     },
//     {
//       key: "2",
//       name: "Mr. Prabhat Ranjan",
//       designation: "Dy. Manager - BE&CR",
//       mobile: "7065049851",
//     },
//     {
//       key: "3",
//       name: "Ms. Neha Rai",
//       designation: "Manager - BE&CR",
//       mobile: "7065049852",
//     },
//   ];

//   const customerRelationsHead = [
//     {
//       key: "1",
//       name: "Ms. Meghna Dosi",
//       designation: "Head - BE&CR",
//       mobile: "7840008873",
//     },
//   ];

//   const newConnectionData = [
//     {
//       key: "1",
//       subHeading: "New Connection(LT URBAN - Upto 50 KW)",
//       name: "Mr. Amit Kumar",
//       designation: "Dy. Manager - (Distribution Technical)",
//       mobile: "9911998247",
//     },
//     {
//       key: "2",
//       subHeading: "New Connection(LT RURAL - Upto 50 KW)",
//       name: "Mr. Sushil Sonar",
//       designation: "Manager - (Distribution Technical)",
//       mobile: "7834807046",
//     },
//     {
//       key: "3",
//       subHeading:
//         "New Connection(HT - > 50 KW)",
//       name: "Mr. Akash Vishwakarma",
//       designation: "Manager - (Distribution Technical)",
//       mobile: "8750068225",
//     },
//     {
//       key: "4",
//       subHeading: "Coversion of single point connection to multi point connection for multi-storied building",
//       name: "Mr. Tarun Chauhan",
//       designation: "Assistant Manager - (Distribution Technical)",
//       mobile: "9911998208",
//     },
//     {
//       key: "5",
//       subHeading: "New Connection Head",
//       name: "Mr. Pankaj Palawat",
//       designation: "Sr. Manager - (Distribution TechnicaL)",
//       mobile: "8287238929",
//     },
//   ];

//   const commercialServicesData = [
//     {
//       key: "1",
//       subHeading: "Reconnection / Disconnection",
//       name: "Mr. Ritesh Kumar Gupta",
//       designation: "Sr. Executive - Commercial",
//       mobile: "9355455678",
//     },
//     {
//       key: "2",
//       subHeading: "Reconnection / Disconnection (Rural)",
//       name: "Mr. Tarun Raj",
//       designation: "Dy.Manager - Commercial Recovery",
//       mobile: "9911998254",
//     },
//     {
//       key: "3",
//       subHeading: "Meter reading & Billing",
//       name: "Mr. Abhishake Jain",
//       designation: "DGM - Commercial",
//       mobile: "9718804962",
//     },
//     {
//       key: "4",
//       subHeading:
//         "Commercial services (Name mutation/load reduction/category transfer/Permanent disconnection/Security deposit refund)",
//       name: "Mr. Navin Kumar",
//       designation: "Manager - Commercial",
//       mobile: "9891701264",
//     },
//     {
//       key: "5",
//       subHeading: "Advertisement on Bill",
//       name: "Mr. Harinder SingMr. Nikhil Garg",
//       designation: "DGM - Commercial",
//       mobile: "9990046406",
//     },
//     {
//       key: "6",
//       subHeading: "Overall",
//       name: "Mr. Praveen Goyal",
//       designation: "Head - Commercial",
//       mobile: "9718065622",
//     },
//   ];

//   const contactColumns = [
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       render: (text) => (
//         <Space size="small">
//           <UserOutlined style={styles.contactIcon} />
//           <Text strong style={{ fontSize: "13px" }}>
//             {text}
//           </Text>
//         </Space>
//       ),
//     },
//     {
//       title: "Designation",
//       dataIndex: "designation",
//       key: "designation",
//       render: (text) => <Text style={{ fontSize: "13px" }}>{text}</Text>,
//     },
//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//       key: "mobile",
//       render: (text) => (
//         <Space size="small">
//           <PhoneOutlined style={styles.phoneContactIcon} />
//           <Text copyable style={{ fontSize: "13px" }}>
//             {text}
//           </Text>
//         </Space>
//       ),
//     },
//   ];

//   const newConnectionColumns = [
//     {
//       title: "Service",
//       dataIndex: "subHeading",
//       key: "subHeading",
//       width: "40%",
//       render: (text) => <Text style={{ fontSize: "13px" }}>{text}</Text>,
//     },
//     {
//       title: "Name",
//       dataIndex: "name",
//       key: "name",
//       render: (text) => (
//         <Space size="small">
//           <UserOutlined style={styles.contactIcon} />
//           <Text strong style={{ fontSize: "13px" }}>
//             {text}
//           </Text>
//         </Space>
//       ),
//     },
//     {
//       title: "Designation",
//       dataIndex: "designation",
//       key: "designation",
//       render: (text) => <Text style={{ fontSize: "13px" }}>{text}</Text>,
//     },
//     {
//       title: "Mobile",
//       dataIndex: "mobile",
//       key: "mobile",
//       render: (text) => (
//         <Space size="small">
//           <PhoneOutlined style={styles.phoneContactIcon} />
//           <Text copyable style={{ fontSize: "13px" }}>
//             {text}
//           </Text>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <style>{customStyles}</style>
//       <div id="bodyaddid">
//         <Header />
//         <FixMenu />
//         <div style={styles.container}>
//           <div style={styles.mainContainer}>
//             <Card style={styles.mainCard} className="mt-5">
//               <div style={styles.contactHeader}>
//                 <Title
//                   level={3}
//                   style={styles.contactTitle}
//                   className="contact-title"
//                 >
//                   <PhoneOutlined
//                     style={styles.titleIcon}
//                     className="title-icon"
//                   />
//                   Contact Over Phone
//                 </Title>
//               </div>
//               <div style={styles.quickContactSection}>
//                 <Row gutter={[16, 12]}>
//                   <Col xs={24} md={8}>
//                     <Card
//                       style={styles.quickContactCard}
//                       className="quick-contact-card"
//                       hoverable
//                     >
//                       <Space direction="vertical" align="center" size="small">
//                         <PhoneOutlined
//                           style={{
//                             ...styles.quickContactIcon,
//                             ...styles.phoneIcon,
//                           }}
//                         />
//                         <Text strong style={{ fontSize: "12px" }}>
//                           24*7 Call Center
//                         </Text>
//                         <Title level={5} style={styles.contactNumber}>
//                           0120 - 622 6666
//                         </Title>
//                       </Space>
//                     </Card>
//                   </Col>
//                   <Col xs={24} md={8}>
//                     <Card
//                       style={styles.quickContactCard}
//                       className="quick-contact-card"
//                       hoverable
//                     >
//                       <Space direction="vertical" align="center" size="small">
//                         <MailOutlined
//                           style={{
//                             ...styles.quickContactIcon,
//                             ...styles.emailIcon,
//                           }}
//                         />
//                         <Text strong style={{ fontSize: "12px" }}>
//                           No Power Complaint E-mail
//                         </Text>
//                         <Text copyable style={styles.emailText}>
//                           nocurrentnpcl@rpsg.in
//                         </Text>
//                       </Space>
//                     </Card>
//                   </Col>
//                   <Col xs={24} md={8}>
//                     <Card
//                       style={styles.quickContactCard}
//                       className="quick-contact-card"
//                       hoverable
//                     >
//                       <Space direction="vertical" align="center" size="small">
//                         <MailOutlined
//                           style={{
//                             ...styles.quickContactIcon,
//                             ...styles.emailIcon,
//                           }}
//                         />
//                         <Text strong style={{ fontSize: "12px" }}>
//                           General Query complaint E-mail
//                         </Text>
//                         <Text copyable style={styles.emailText}>
//                           crmnpcl@rpsg.in
//                         </Text>
//                       </Space>
//                     </Card>
//                   </Col>
//                 </Row>
//               </div>
//               <div style={styles.detailedContactSection}>
//                 <Tabs defaultActiveKey="1" className="contact-tabs" size="small">
//                   <TabPane tab="Customer Relations" key="1">
//                     <Card
//                       style={styles.tabContentCard}
//                       className="tab-content-card"
//                     >
//                       <Title
//                         level={5}
//                         style={{ margin: "0 0 10px 0", fontSize: "16px" }}
//                       >
//                         General queries / requests / complaints / information
//                       </Title>
//                       <Table
//                         dataSource={customerRelationsData}
//                         columns={contactColumns}
//                         pagination={false}
//                         className="contact-table"
//                         size="small"
//                       />
//                       <Divider style={{ margin: "15px 0 10px 0" }} />
//                       <Title
//                         level={5}
//                         style={{ margin: "0 0 10px 0", fontSize: "14px" }}
//                       >
//                         Overall Head
//                       </Title>
//                       <Table
//                         dataSource={customerRelationsHead}
//                         columns={contactColumns}
//                         pagination={false}
//                         className="contact-table"
//                         size="small"
//                       />
//                     </Card>
//                   </TabPane>

//                   <TabPane tab="New Connection" key="2">
//                     <Card
//                       style={styles.tabContentCard}
//                       className="tab-content-card"
//                     >
//                       <Table
//                         dataSource={newConnectionData}
//                         columns={newConnectionColumns}
//                         pagination={false}
//                         className="contact-table"
//                         size="small"
//                       />
//                     </Card>
//                   </TabPane>

//                   <TabPane tab="Operations & Maintenance" key="3">
//                     <Card
//                       style={styles.tabContentCard}
//                       className="tab-content-card"
//                     >
//                       <Title
//                         level={5}
//                         style={{ margin: "0 0 10px 0", fontSize: "16px" }}
//                       >
//                         Operations & Maintenance Contact Information
//                       </Title>
//                       <Text style={{ fontSize: "13px" }}>
//                         Please refer to the detailed contact information for
//                         Operations & Maintenance services.
//                       </Text>
//                     </Card>
//                   </TabPane>

//                   <TabPane tab="Commercial Services" key="4">
//                     <Card
//                       style={styles.tabContentCard}
//                       className="tab-content-card"
//                     >
//                       <Table
//                         dataSource={commercialServicesData}
//                         columns={newConnectionColumns}
//                         pagination={false}
//                         className="contact-table"
//                         size="small"
//                       />
//                     </Card>
//                   </TabPane>
//                 </Tabs>
//               </div>

//               <div style={styles.officeHoursNotice}>
//                 <Card style={styles.noticeCard} className="notice-card">
//                   <Text style={styles.noticeText}>
//                     📞 Calls to NPCL officials shall be accepted during office
//                     hours.
//                   </Text>
//                 </Card>
//               </div>
//             </Card>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ContactOverPhone;